const ReciprocalOperator = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" width="13" height="13">
            <g fill="none" fillRule="evenodd" stroke="currentColor">
                <path strokeLinecap="square" strokeLinejoin="round" d="M3.5 10V2.5L1 5"></path>
                <path strokeLinecap="square" d="M1.5 10.5h4"></path>
                <path d="M8 12l3-11"></path>
            </g>
        </svg>
    )
}
export default ReciprocalOperator